import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {
  DateValidationError,
  PickerChangeHandlerContext,
} from '@mui/x-date-pickers';
import { Dayjs } from 'dayjs';
import {
  FormControl,
  FormHelperText,
  FormLabel,
  Grid,
  Paper,
} from '@mui/material';
import { BLUE_GRAY_200, ERROR, GRAY_50, PRIMARY } from '../../constants/Colors';
import { t } from 'i18next';
import BakeasyCheckbox from './BakeasyCheckbox';
import { useState } from 'react';

interface BakeasyDatePickerProps {
  label: string;
  value?: any;
  required?: any;
  disabled?: boolean;
  viewAllOrders?: boolean | false;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>, params?: any) => void;
  onChange?: (
    value: Dayjs | null,
    context: PickerChangeHandlerContext<DateValidationError>
  ) => void;
}

function BakeasyDatePicker(props: BakeasyDatePickerProps) {
  return (
    <FormControl fullWidth>
      <FormLabel
        sx={{ fontWeight: 'bold', fontSize: '0.95rem', marginBottom: 0.5 }}
      >
        {props.label}
        {props?.required}
      </FormLabel>
      <DatePicker
        disabled={props?.disabled}
        closeOnSelect={true}
        onChange={(
          value: any,
          context: PickerChangeHandlerContext<DateValidationError>
        ) => {
          props?.onChange && props?.onChange(value, context);
          // if (remember) {
          //   setRemember(false)
          // }
        }}
        views={['year', 'month', 'day']}
        format={'YYYY-MM-DD'}
        //maxDate={dayjs(new Date())}
        value={props?.value}
        slotProps={{ textField: { size: 'small' } }}
        sx={{
          '& .MuiInputBase-input::placeholder': { fontSize: '0.9rem' },
          '& .MuiOutlinedInput-root': { borderRadius: 2 },
          '& .MuiOutlinedInput-notchedOutline': { borderColor: BLUE_GRAY_200 },
          '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: BLUE_GRAY_200,
            borderWidth: 1.5,
          },
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
            {
              borderColor: PRIMARY,
            },
        }}
      />
    </FormControl>
  );
}

export default BakeasyDatePicker;

export function BakeasyDueDatePicker(props: BakeasyDatePickerProps) {
  const [remember, setRemember] = useState(false);

  return (
    <FormControl fullWidth>
      <FormLabel
        sx={{ fontWeight: 'bold', fontSize: '0.95rem', marginBottom: 0.5 }}
      >
        <Grid item>
          {props.label}
          {props?.required}
        </Grid>
      </FormLabel>
      <DatePicker
        disabled={props?.disabled}
        closeOnSelect={true}
        onChange={(
          value: any,
          context: PickerChangeHandlerContext<DateValidationError>
        ) => {
          props?.onChange && props?.onChange(value, context);
          // if (remember) {
          //   setRemember(false)
          // }
        }}
        views={['year', 'month', 'day']}
        // format={'MM/DD/YYYY'}
        format={'YYYY-MM-DD'}
        value={props?.value}
        sx={{ '& .MuiInputBase-input': { paddingY: 1 } }}
        slotProps={{ textField: { size: 'small' } }}
      />
      <FormHelperText
        id="outlined-weight-helper-text"
        sx={{
          '&.MuiFormHelperText-root': {
            marginX: -1,
            color: ERROR,
            fontSize: '0.8rem',
          },
        }}
      >
        <BakeasyCheckbox
          style={{ marginLeft: 0, marginTop: -1.5 }}
          label={t('VIEW_ALL_ORDERS')}
          value={remember}
          onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
            setRemember(!remember);
            props?.onClick?.(event, !remember);
          }}
        />
      </FormHelperText>
    </FormControl>
  );
}
